import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeeTypeSearch } from '../fee-type/fee-type-search.model';
import { IFeeType } from '../shared/model/fee-type.model';
import { logRequest } from '../shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class FeeTypeService {
    baseUrl = '/school-service/api/fee-types';

    constructor(private http: HttpClient) {}

    getAll(): Observable<IFeeType[]> {
        return this.http.get<IFeeType[]>(this.baseUrl);
    }

    getActives(): Observable<IFeeType[]> {
        return this.http.get<IFeeType[]>(`${this.baseUrl}/active`);
    }

    getById(id: string): Observable<HttpResponse<IFeeType>> {
        return this.http.get<IFeeType>(`${this.baseUrl}/${id}`, {
            observe: 'response',
        });
    }

    delete(discount: IFeeType): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${discount.id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    create(discount: IFeeType): Observable<HttpResponse<IFeeType>> {
        console.log(discount);
        return this.http.post<IFeeType>(this.baseUrl, discount, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    update(discount: IFeeType): Observable<HttpResponse<IFeeType>> {
        return this.http.put<IFeeType>(this.baseUrl, discount, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    search(search: FeeTypeSearch): Observable<HttpResponse<IFeeType[]>> {
        return this.http.post<IFeeType[]>(`${this.baseUrl}/search`, search, {
            observe: 'response',
        });
    }

    setActive(id: string, isActive: boolean) {
        return this.http.patch(`${this.baseUrl}/${id}/active/${isActive}`, { headers: logRequest() });
    }
}
